import * as React from "react";
import "../../css/News.css";
import { Card, Tabs, Tab, Row, Col, Badge } from "react-bootstrap";
import Select from "react-select";
import countryList from "react-select-country-list";
import Spinner from "../common/Spinner";
import { connect } from "react-redux";
import coffee from "../../images/facepalm.jpg"


class News extends React.PureComponent {
  constructor(props) {
    super(props);

    this.options = countryList().getData();

    this.state = {
      options: this.options,
      value: null,
      headlines: [],
      country: null,
      error: false
    };
  }

  componentDidMount() {
    this.fetchNews("us");
  }

  fetchNews = country => {
    const CORS = "https://cors-anywhere.herokuapp.com/";
    const NEWS_URL =`https://newsapi.org/v2/top-headlines?country=${country}&apiKey=f91a3ae1c8794732a4de50cdd4000a0b`;
    const URL = CORS + NEWS_URL;

    (async () => {
      let response = await fetch(URL);
      if (response.status >= 200 && response.status <= 299) {
        const news = await response.json();
        this.setState({ headlines: news.articles });
      } else {
        // Handle errors
        this.setState({error: true});
      }
    })(); 
  };

  changeHandler = country => {
    this.fetchNews(country.value.toLowerCase());
  };

  render() {
    if (this.state.error) {
      return (
        <div className="error-container">
         <img src={coffee} alt="Coffee" style={{'width':'100%'}}/>
          <div className="error-centered">Oh Man...! I gottta go back to School again...!</div>
       </div>
      );
    } else if(this.state && this.state.headlines.length === 0) {
      return <Spinner />;
    } 
    else {
      return (
        <div className="top-headlines">
          <strong>Choose Country</strong>
          <Select
            options={this.state.options}
            value={this.state.value}
            onChange={this.changeHandler}
            placeholder="Please select country to view the NEWS"
          />
          <br />
          <h1>TOP HEADLINES</h1>
          {this.state.headlines.map((article, index) => {
            return (
              <Card className="newsCard" key={index}>
                <Card.Body>
                  <Tabs
                    defaultActiveKey="Headline"
                    id="uncontrolled-tab-example"
                    className="bold"
                  >
                    <Tab eventKey="Headline" title="Headline" className="news">
                      <Row>
                        <Col sm={5} md={4}>
                          <img
                            src={article.urlToImage}
                            variant="top"
                            className="newsImage"
                            alt=""
                          />
                        </Col>
                        <Col sm={7} md={8}>
                          <p>{article.title}</p>
                        </Col>
                        <Col sm={12} md={12}>
                          <Badge pill variant="info" className="newsBadge">
                            {article.source.name}
                          </Badge>
                        </Col>
                      </Row>
                    </Tab>
                    <Tab eventKey="News" title="News" className="news">
                       <p>{article.content}</p>
                      <Row>
                        <Col sm={12} md={12}>
                          <Badge pill variant="info">
                            {"Author : " + article.author}
                          </Badge>
                        </Col>
                      </Row>
                    </Tab>
                    <Tab eventKey="MoreInfo" title="More Info" className="news">
                      <p>{article.description}</p>
                      <a
                        href={article.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Read More...
                      </a>
                    </Tab>
                  </Tabs>
                </Card.Body>
              </Card>
            );
          })}
          <strong>
            Source & Thanks to: <a href="https://newsapi.org">NEWS API</a>
          </strong>
        </div>
      );
     
    }
  }
}

const MapStateToProps = (store) => {
  return {
    lat: store.lat,
    lng: store.lng,
    country: store.country
  };
};



export default connect(
  MapStateToProps,
  {}
)(News);
